export default "__VITE_ASSET__d93b022d__"